/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Orgmanagerv1Checks } from '../models/Orgmanagerv1Checks';
import { Orgmanagerv1HealthCondition } from '../models/Orgmanagerv1HealthCondition';
import { HttpFile } from '../http/http';

export class Orgmanagerv1HealthCheck {
    'serviceName'?: string;
    'healthCondition'?: Orgmanagerv1HealthCondition;
    'commitHash'?: string;
    'serviceVersion'?: string;
    'checks'?: Orgmanagerv1Checks;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "healthCondition",
            "baseName": "healthCondition",
            "type": "Orgmanagerv1HealthCondition",
            "format": ""
        },
        {
            "name": "commitHash",
            "baseName": "commitHash",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceVersion",
            "baseName": "serviceVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "checks",
            "baseName": "checks",
            "type": "Orgmanagerv1Checks",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Orgmanagerv1HealthCheck.attributeTypeMap;
    }

    public constructor() {
    }
}

